import Vue from "vue";
import Vuex from "vuex";
import orders from "./modules/orders.js";
import customers from "./modules/customers.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    orders,
    customers
  },
  state: {
    isOpenMobileSidebar: false,
    quickSearchType: null,
    user: {
      id: 123456,
      name: "Guest",
      username: "guest",
      isAuthenticated: false,
      cognitoInfo: {},
      loggedIn: false,
    },
    notifications: [
      // { content: "Notification 1" },
      // { content: "Notification 2" },
      // { content: "Another stupid notification" }
    ]
  },
  mutations: {
    toggleMobileSidebar(state) {
      state.isOpenMobileSidebar = !state.isOpenMobileSidebar;
    },
    removeNotification(state, id) {
      state.notifications.splice(id, 1);
    },
    setQuickSearchType(state, type) {
      state.quickSearchType = type;
    },
    setUser(state, user) {
      state.user.name = user.name ?? "Guest";
      state.user.username = user.username ?? "guest";
      state.user.isAuthenticated = user.isAuthenticated ?? false;
    },
    setLoggedIn(state) {
      state.user.loggedIn = true;
    },
    setLoggedOut(state) {
      state.user.loggedIn = false;
      state.user.cognitoInfo = {};
    },
    setCognitoInfo(state, newValue) {
      state.user.cognitoInfo = newValue;
    }
  },
  actions: {
    logout({ commit }) {
      localStorage.clear();
      commit('setUser', {});
      commit('setLoggedOut');
    },
    async initializeUser({ commit }) {
      if(localStorage.getItem("user_info")) {
        await commit('setLoggedIn');
        await commit('setCognitoInfo', JSON.parse(localStorage.getItem("user_info")));
      }
    }
  },
  getters: {
    isOpenMobileSidebar(state) {
      return state.isOpenMobileSidebar;
    },
    quickSearchType(state) {
      return state.quickSearchType;
    },
    isLoggedIn(state){
      return state.loggedIn;
    },
    userGroups(state){
      return state.user.cognitoInfo.groups
    },
  }
});
